import { Game } from "../../types/models";

export type GameState = Game["state"];

export interface GameStatusOption {
  value: GameState;
  /** What a scorekeeper calls it. "Live" and "Final" are the words used on the
   *  public schedule and standings, so the scoreboard uses them too. */
  label: string;
  /** Bootstrap badge variant. Live is red because it is the state that means
   *  something is happening right now. */
  variant: string;
}

/** In the order a game moves through them, which is also the order shown. */
export const GAME_STATUS_OPTIONS: GameStatusOption[] = [
  { value: "scheduled", label: "Scheduled", variant: "secondary" },
  { value: "playing", label: "Live", variant: "danger" },
  { value: "completed", label: "Final", variant: "success" },
];

export function gameStatusFor(state: GameState): GameStatusOption {
  return (
    GAME_STATUS_OPTIONS.find((option) => option.value === state) ??
    GAME_STATUS_OPTIONS[0]
  );
}
